import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDyl9Eji474mAlfVvYzw1zOwjrPhy94Bao",
  authDomain: "uniform-2nd-hand.firebaseapp.com",
  projectId: "uniform-2nd-hand",
  storageBucket: "uniform-2nd-hand.firebasestorage.app",
  messagingSenderId: "1006985388173",
  appId: "1:1006985388173:web:c79493f64719f4233742c4",
  measurementId: "G-WLX7VNX4SV"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const provider = new GoogleAuthProvider();
export const db = getFirestore(app);
export const storage = getStorage(app);
